// extracted by mini-css-extract-plugin
export default {"wrap":"us-z","fullWidth":"vs-z","items":"ws-z","featureCss":"xs-z","disabled":"ys-z","imgCss":"zs-z"};